import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: ticketColors.bg,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
  },
  containerCompact: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
  },
  stockList: {
    flex: 1,
  },
  /** ScrollView content (unified mobile+desk). */
  scrollContent: {
    paddingTop: 0,
    paddingBottom: spacing.xxl,
  },
  scrollContentEmpty: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  /** Stack de PaperSheets (header + KPIs + strip + lista). */
  stack: {
    gap: 10,
  },
  /** Mobile: trigger "Filtros" ocupa el ancho libre en la fila con "Más". */
  filterTriggerMobile: {
    flex: 1,
    marginBottom: 0,
  },
  /** PaperSheet que envuelve la lista de filas soft. */
  listSheet: {
    overflow: 'hidden',
  },
  /** Strip warn "X debajo del mínimo" — tocá para filtrar. */
  alertStrip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: 'rgba(250, 204, 21, 0.42)',
    backgroundColor: 'rgba(250, 204, 21, 0.08)',
  },
  alertDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: ticketColors.gold,
    flexShrink: 0,
  },
  alertTextWrap: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  alertTitle: {
    ...typography.caption,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  alertSubtitle: {
    ...typography.caption,
    fontSize: 11,
    color: ticketColors.ink3,
    fontWeight: '600',
  },
  /** Fila inline «error de variantes + retry» dentro del grupo expandido. */
  variantErrorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingHorizontal: 14,
    paddingVertical: 10,
    marginLeft: 16,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
  },
  variantErrorText: {
    flex: 1,
    ...typography.caption,
    color: ticketColors.bad,
    fontWeight: '600',
  },
  variantErrorRetry: {
    ...typography.caption,
    color: ticketColors.brandPrimary,
    fontWeight: '700',
  },
  emptyState: {
    marginTop: spacing.md,
    padding: spacing.lg,
    alignItems: 'center',
    gap: spacing.sm,
  },
  emptyStateFull: {
    flex: 1,
    justifyContent: 'center',
    paddingHorizontal: spacing.xl,
  },
  loadingState: {
    marginTop: spacing.lg,
    padding: spacing.lg,
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
  },
  footerLoading: {
    paddingVertical: spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
  },
  footerEnd: {
    paddingTop: spacing.md,
    paddingBottom: spacing.xl,
    alignItems: 'center',
  },
  footerEndText: {
    ...typography.caption,
    color: ticketColors.ink3,
    fontWeight: '700',
  },
  wideListFooter: {
    width: '100%',
    marginTop: spacing.md,
    gap: spacing.sm,
    alignItems: 'stretch',
  },
  wideLoadMoreBtn: {
    alignSelf: 'center',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.xl,
  },
});
